import React from "react";
import { useFormContext } from "react-hook-form";

import { CustomCalendar } from "components/CustomCalendar/CustomCalendar";
import { FormField } from "components/form/FormField/FormField";

import style from "../AddVaccineForm.module.css";

export const DateField = ({
  name,
  label,
  placeholder = "Select date",
  disabled = false,
  minDate,
  maxDate,
  helperText,
  required = false,
  ariaRequired = false,
}) => {
  const { watch, setValue } = useFormContext();
  const value = watch(name);

  const handleChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      setValue(name, `${year}-${month}-${day}`);
    } else {
      setValue(name, "");
    }
  };

  return (
    <FormField name={name}>
      <label className={style.pregnancyFormLabel}>
        {label}
        {required ? " *" : ""}
      </label>
      <div {...(required || ariaRequired ? { "aria-required": "true" } : undefined)}>
      <CustomCalendar
        value={value && value !== "" ? value : null}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        error={false}
      />
      </div>
      {helperText && (
        <p className={style.reactionFieldLabelText}>{helperText}</p>
      )}
    </FormField>
  );
};
